import { createPalette } from "./create-palette";
import { typography } from "./typography";
import { createComponents } from "./create-components";
import { createTheme, type PaletteMode, type Theme } from "@mui/material";
/**
 * Crea un tema dinámico según el modo (light/dark)
 */
export function createAppTheme(mode: PaletteMode = "light"): Theme {
  const palette = createPalette(mode);
  // Crear tema base con paleta
  const baseTheme = createTheme({
    palette,
    typography,
    shape: {
      borderRadius: 12,
    },
    spacing: 8,
    shadows:
      mode === "light"
        ? ([
            "none",
            "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
            "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
            "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
            "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
            "0 25px 50px -12px rgb(0 0 0 / 0.25)",
            ...Array(19).fill("0 25px 50px -12px rgb(0 0 0 / 0.25)"),
          ] as any)
        : ([
            "none",
            "0 1px 3px 0 rgb(0 0 0 / 0.3), 0 1px 2px -1px rgb(0 0 0 / 0.3)",
            "0 4px 6px -1px rgb(0 0 0 / 0.3), 0 2px 4px -2px rgb(0 0 0 / 0.3)",
            "0 10px 15px -3px rgb(0 0 0 / 0.3), 0 4px 6px -4px rgb(0 0 0 / 0.3)",
            "0 20px 25px -5px rgb(0 0 0 / 0.3), 0 8px 10px -6px rgb(0 0 0 / 0.3)",
            "0 25px 50px -12px rgb(0 0 0 / 0.5)",
            ...Array(19).fill("0 25px 50px -12px rgb(0 0 0 / 0.5)"),
          ] as any),
    breakpoints: {
      values: {
        xs: 0,
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280,
      },
    },
  });
  // Agregar componentes que dependen del tema
  const components = createComponents(baseTheme);
  return createTheme({
    ...baseTheme,
    components,
  });
}
// Tema por defecto (light)
export const theme = createAppTheme("light");
export default theme;
// Re-exportar funciones útiles
export {
  createPalette,
  getNomenclatorColor,
  getAllNomenclatorColors,
} from "./create-palette";
export type { NomenclatorColorKey } from "./create-palette";
